export const paths: {
  path: string;
  label: string;
  always?: boolean;
  adminOnly?: boolean;
  loggedInOnly?: boolean;
  publicOnly?: boolean;
}[] = [
  { path: '/logout', label: 'Logout', loggedInOnly: true },
  { path: '/login', label: 'Login', publicOnly: true },
];
